// test1068
(1068 && 0);
